import React from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";

// styled components
import { ErrorStyled, ErrorStyledContainer, ErrorWarningText } from "./ErrorWrapper.styled";
import LoginHook from "../../../hooks/LoginHooks";
import appHooks from "../../../hooks/appHook";

const Error = ({ errorText, errorHeading, errorLink, errorLinkText, errorCallback, externalLink, ariaLabelForLink, loginPrompt }) => {
    const { openLoginModal, openSignupModal } = LoginHook();
    const { values } = appHooks();
    const history = useHistory();
    return (
        <ErrorStyled>
            <ErrorStyledContainer>
                <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.23201 22H21.768C21.9376 22 22.0495 21.8209 21.9728 21.6674L12.2049 2.12679C12.1745 2.06603 12.1447 2.04325 12.1234 2.03066C12.0951 2.01396 12.0524 2 12 2C11.9476 2 11.9049 2.01396 11.8766 2.03066C11.8553 2.04325 11.8255 2.06603 11.7951 2.12679L2.02715 21.6674C1.95046 21.8209 2.06238 22 2.23201 22ZM13.9938 1.23253C13.1723 -0.410843 10.8277 -0.410844 10.0062 1.23253L0.238212 20.7732C-0.502865 22.2557 0.574913 24 2.23201 24H21.768C23.4251 24 24.5029 22.2557 23.7618 20.7732L13.9938 1.23253ZM12 6C12.5523 6 13 6.44772 13 7V13.9978C13 14.5501 12.5523 14.9978 12 14.9978C11.4477 14.9978 11 14.5501 11 13.9978V7C11 6.44772 11.4477 6 12 6ZM12 16.9978C12.5523 16.9978 13 17.4455 13 17.9978V18.9978C13 19.5501 12.5523 19.9978 12 19.9978C11.4477 19.9978 11 19.5501 11 18.9978V17.9978C11 17.4455 11.4477 16.9978 12 16.9978Z" fill="#856404" />
                </svg>
                <div>
                    {errorHeading && (
                        <>
                            <ErrorWarningText>{errorHeading}</ErrorWarningText>
                        </>
                    )}
                    {errorText && (
                        <>
                            <p>
                                {errorText}
                                {externalLink && errorLinkText && (
                                    <>
                                        <a href={externalLink} target="_blank" rel="noopener noreferrer" aria-label={ariaLabelForLink}>
                                            {errorLinkText}
                                        </a>
                                    </>
                                )}
                            </p>
                        </>
                    )}

                    {errorLink && errorLinkText && (
                        <>
                            <button
                                type="button"
                                onClick={() => {
                                    history.push(errorLink);
                                }}
                                aria-label={ariaLabelForLink}
                            >
                                {errorLinkText}
                            </button>
                        </>
                    )}

                    {errorCallback && errorLinkText && (
                        <>
                            <Link href="/" onClick={e => errorCallback(e)}>
                                {errorLinkText}
                            </Link>
                        </>
                    )}

                    {loginPrompt && (
                        <>
                            {values.isAppV4OrHigher ? (
                                <>
                                    <Link href="anpost://login">
                                        Log in
                                    </Link>
                                    <span> or </span>
                                    <Link href="anpost://signup">
                                        sign up
                                    </Link>
                                </>
                            ) : (
                                <>
                                    <Link href="/" onClick={openLoginModal}>
                                        Log in
                                    </Link>
                                    <span> or </span>
                                    <Link href="/" onClick={openSignupModal}>
                                        sign up
                                    </Link>
                                </>
                            )}
                            <span> here</span>
                        </>
                    )}
                </div>
            </ErrorStyledContainer>
        </ErrorStyled>
    );
};

// props validation
Error.propTypes = {
    errorText: PropTypes.array.isRequired,
    errorHeading: PropTypes.string,
    errorLink: PropTypes.string,
    errorLinkText: PropTypes.string,
    errorCallback: PropTypes.func,
    externalLink: PropTypes.string,
    ariaLabelForLink: PropTypes.string,
    loginPrompt: PropTypes.bool
};

export default Error;
